// extracted by mini-css-extract-plugin
export default {"wrapper":"shareIcons__wrapper__I_pff"};